import React, { useEffect, useRef, useState } from "react";
import "./App.css";
import EnvironmentProvider from "./Analytics/EnvironmentContext";
import { Provider } from "react-redux";
import store from "./redux/store";

function App() {
  const [shouldUpdate, setShouldUpdate] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    if (shouldUpdate) setShouldUpdate(false);
  }, [shouldUpdate]);

  return (
    <Provider store={store}>
      <div className="delicious100-interactive__app" ref={containerRef}>
        <EnvironmentProvider
          initialProps={{
            type: "delicious100-sa-interactive",
            rootEl: containerRef.current,
          }}
          data={{
            type: "delicious100-sa-interactive",
          }}
        ></EnvironmentProvider>
      </div>
    </Provider>
  );
}

export default App;
